import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import PropTypes from 'prop-types';
import { withRouter } from '../_helpers/withRouter';
import { connect, useDispatch } from "react-redux";
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import { Button, Form, FormGroup } from 'reactstrap';
import { history } from '../_helpers';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { usuarioAction } from '../_actions';
import alerts from '../_components/alerts';

const styles = theme => ({
    paper: {
        marginTop: theme.spacing,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar:
    {
        margin: theme.spacing,
        backgroundColor: theme.palette,
        width: theme.spacing,
        height: theme.spacing,
    },
    form:
    {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing,
    },
    submit:
    {
        margin: theme.spacing,
        color: '#ffffff'
    },
    backButton:
    {
        marginTop: theme.spacing,
    }
});

const RequestPasswordReset = (props) => {

    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const { classes } = props;
    const { match: { params } } = props;

    const handleChange = prop => event => {
        setEmail(event.target.value);
    };

    const handleSubmit = (event) => {
        if (email != '') {
            setSubmitted(true, () => {               
                setTimeout(() => setSubmitted(false), 5000);
            });

            let payload = {
                email: email.toLowerCase().trim()
            };
            dispatch(usuarioAction.requestPasswordReset(payload));
        } else {
            alerts.warning("Preencha o e-mail");
        }
    }

    return (
        <Container component={Paper} maxWidth="sm">
            <CssBaseline />
            <div className={classes.paper}>
                <Grid container justifyContent="flex-start" sx={{ width: '100%' }}>
                    <IconButton className={classes.backButton} onClick={() => history.goBack()} aria-label="Voltar" color="primary">
                        <KeyboardBackspaceIcon />
                    </IconButton>
                </Grid>
                <Typography component="h2" variant="h6">
                    Informe o endereço de e-mail utilizado no cadastro, para recuperar a senha.
                </Typography>
                <Form style={{ marginTop: 10 }}>
                    <FormGroup className="input-group mb-2">
                        <input
                            autoFocus
                            type="text"
                            name="email"
                            id="email"
                            value={email}
                            className="form-control"
                            onChange={handleChange('email')}
                            placeholder="E-mail"
                        />
                    </FormGroup>
                    <div className="d-flex justify-content-center mt-3 login_container" style={{ marginBottom: 10 }}  >
                        <Button block
                            onClick={(event) => handleSubmit(event)}
                            variant="contained"
                            color="primary"
                            disabled={submitted}
                            className={submitted === true ? 'login_btn' : 'login_btn'}
                        >
                            {
                                (submitted && 'Enviando informações...')
                                || (!submitted && 'ENVIAR E-MAIL DE RECUPERAÇÃO DE SENHA')
                            }
                        </Button>

                    </div>

                </Form>

            </div>
        </Container>
    );
}

RequestPasswordReset.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return state;
}
const connectedRequestPasswordResetPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(withStyles(styles)(RequestPasswordReset)));
export { connectedRequestPasswordResetPage as RequestPasswordReset };
